document.addEventListener('DOMContentLoaded', function() {
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const headerSidebarBanner = entry.target;
        initializeHeaderSidebarSwiper(headerSidebarBanner);
        headerSidebarBanner.style.cursor = 'pointer';
        headerSidebarBanner.classList.add('custom-header-sidebar-banner');
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px'
  });
  
  function initializeHeaderSidebarSwiper(bannerElement) {
    const swiperContainer = bannerElement.querySelector('.header-sidebar__banner-swiper');
    
    if (swiperContainer && typeof Swiper !== 'undefined') {
      const swiper = new Swiper('.header-sidebar__banner-swiper', {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoHeight: true,
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 0
          }
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'bullets'
        }
      });
    }
  }
  
  function observeHeaderSidebarBanners() {
    const headerSidebarBanners = document.querySelectorAll('header-sidebar-banner');
    headerSidebarBanners.forEach((banner, index) => {
      observer.observe(banner);
    });
  }
  
  observeHeaderSidebarBanners();
  
  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.tagName === 'HEADER-SIDEBAR-BANNER') {
            observer.observe(node);
          }
          
          const banners = node.querySelectorAll ? node.querySelectorAll('header-sidebar-banner') : [];
          banners.forEach((banner) => {
            observer.observe(banner);
          });
        }
      });
    });
  });
  
  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  function initHeaderSidebarScrollDetection() {
    const headerSidebar = document.getElementById('sidebar-menu');
    if (!headerSidebar) return;

    let isScrolled = false;

    function handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      if (scrollTop > 0 && !isScrolled) {
        const overlay = headerSidebar.shadowRoot?.querySelector('[part="overlay"]');
        const content = headerSidebar.shadowRoot?.querySelector('[part="content"]');
        
        if (overlay) overlay.classList.add('header-scrolled');
        if (content) content.classList.add('header-scrolled');
        
        isScrolled = true;
      } else if (scrollTop === 0 && isScrolled) {
        const overlay = headerSidebar.shadowRoot?.querySelector('[part="overlay"]');
        const content = headerSidebar.shadowRoot?.querySelector('[part="content"]');
        
        if (overlay) overlay.classList.remove('header-scrolled');
        if (content) content.classList.remove('header-scrolled');
        
        isScrolled = false;
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    handleScroll();
  }

  initHeaderSidebarScrollDetection();

  // Gorgias Chat positioning for product pages
  if (document.body.classList.contains('template-product')) {
    const gorgiasObserver = new MutationObserver(() => {
      if (typeof GorgiasChat !== 'undefined' && GorgiasChat.setPosition) {
        GorgiasChat.setPosition({ offsetY: 100, offsetX: 0, alignment: 'bottom-right' });
        gorgiasObserver.disconnect();
      }
    });
    gorgiasObserver.observe(document.body, { childList: true, subtree: true });
  }

  // Redirect to home page when clicking cart button on cart page
  if (window.location.pathname === '/cart') {
    let cartButtonHandlerAdded = false;
    
    function handleCartButtonOnCartPage() {
      if (cartButtonHandlerAdded) return;
      
      const cartButton = document.querySelector('.header__cart-link a');
      if (cartButton) {
        cartButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          window.location.href = '/';
        }, true); // Use capture phase to intercept before other handlers
        cartButtonHandlerAdded = true;
      }
    }
    
    // Run immediately
    handleCartButtonOnCartPage();
    
    // Also run after a short delay in case header loads after
    setTimeout(handleCartButtonOnCartPage, 100);
  }

  // Enforce quantity = 1 for products with no-quantity tag
  function enforceNoQuantityProducts() {
    // Find all products with no-quantity tag
    const noQuantityProducts = document.querySelectorAll('[data-no-quantity="true"]');
    
    noQuantityProducts.forEach(product => {
      // Find quantity inputs within this product
      const quantityInputs = product.querySelectorAll('input[type="number"][data-line-key]');
      quantityInputs.forEach(input => {
        // Force quantity to 1
        if (parseInt(input.value) !== 1) {
          input.value = 1;
        }
        // Ensure input is readonly and disabled
        input.setAttribute('readonly', 'readonly');
        input.setAttribute('disabled', 'disabled');
        input.setAttribute('data-no-quantity', 'true');
      });
      
      // Disable quantity selector buttons
      const quantityButtons = product.querySelectorAll('.quantity-selector__button');
      quantityButtons.forEach(button => {
        if (!button.disabled) {
          button.disabled = true;
          if (button.tagName === 'A') {
            button.style.pointerEvents = 'none';
            button.style.opacity = '0.5';
          }
        }
      });
    });
  }

  // Intercept quantity changes for no-quantity products
  function interceptQuantityChanges() {
    // Intercept cart change requests
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const url = args[0];
      if (typeof url === 'string' && url.includes('/cart/change.js')) {
        const options = args[1] || {};
        if (options.method === 'POST' && options.body) {
          try {
            const body = JSON.parse(options.body);
            // Find the line item to check if it has no-quantity tag
            const lineItemElement = document.querySelector(`[data-line-key="${body.id}"]`)?.closest('line-item, tr');
            if (lineItemElement && lineItemElement.hasAttribute('data-no-quantity')) {
              // Force quantity to 1
              body.quantity = 1;
              options.body = JSON.stringify(body);
            }
          } catch (e) {
            // If parsing fails, continue with original request
          }
        }
        return originalFetch.apply(this, [url, options]);
      }
      return originalFetch.apply(this, args);
    };

    // Intercept quantity input changes
    document.addEventListener('input', function(event) {
      if (event.target.type === 'number' && event.target.hasAttribute('data-no-quantity')) {
        if (parseInt(event.target.value) !== 1) {
          event.target.value = 1;
          event.preventDefault();
          event.stopPropagation();
        }
      }
    }, true);

    // Intercept quantity selector button clicks for no-quantity products
    document.addEventListener('click', function(event) {
      const button = event.target.closest('.quantity-selector__button');
      if (button) {
        const lineItem = button.closest('line-item, tr');
        if (lineItem && lineItem.hasAttribute('data-no-quantity')) {
          event.preventDefault();
          event.stopPropagation();
          return false;
        }
      }
    }, true);
  }

  // Hide quantity selector for products with specific tags on cart page
  if (window.location.pathname === '/cart') {
    // Configure which tags should hide the quantity selector
    const TAGS_TO_HIDE_QUANTITY = ['no-quantity', 'fixed-quantity', 'bundle'];
    // You can add more tags to this array as needed
    
    function hideQuantitySelectorsBasedOnTags() {
      const cartRows = document.querySelectorAll('.order-summary__body tr[data-product-tags]');
      
      cartRows.forEach(row => {
        const productTags = row.getAttribute('data-product-tags');
        if (!productTags) return;
        
        // Split tags and check if any match our hide list
        const tagsArray = productTags.split(',').map(tag => tag.trim().toLowerCase());
        const shouldHideQuantity = TAGS_TO_HIDE_QUANTITY.some(hideTag => 
          tagsArray.includes(hideTag.toLowerCase())
        );
        
        if (shouldHideQuantity) {
          // Hide the quantity selector in the middle column
          const quantityCell = row.querySelector('td:nth-child(2) .quantity-selector');
          if (quantityCell) {
            quantityCell.style.display = 'none';
          }
          
          // Also hide the quantity selector in the line-item (mobile view)
          const mobileQuantitySelector = row.querySelector('line-item-quantity .quantity-selector');
          if (mobileQuantitySelector) {
            mobileQuantitySelector.style.display = 'none';
          }
        }
      });
    }
    
    // Run immediately
    hideQuantitySelectorsBasedOnTags();
    enforceNoQuantityProducts();
    
    // Also run after a short delay to ensure DOM is fully loaded
    setTimeout(() => {
      hideQuantitySelectorsBasedOnTags();
      enforceNoQuantityProducts();
    }, 100);
  }

  // Initialize quantity enforcement
  enforceNoQuantityProducts();
  interceptQuantityChanges();

  // Function to correct quantities for no-quantity products in cart
  async function correctNoQuantityProductsInCart() {
    const noQuantityProducts = document.querySelectorAll('[data-no-quantity="true"]');
    const corrections = [];
    
    noQuantityProducts.forEach(product => {
      const lineKey = product.querySelector('[data-line-key]')?.getAttribute('data-line-key');
      if (lineKey) {
        // Check if quantity is not 1
        const quantityInput = product.querySelector('input[type="number"][data-line-key]');
        const quantityDisplay = product.querySelector('td:nth-child(2) span');
        
        let currentQuantity = 1;
        if (quantityInput) {
          currentQuantity = parseInt(quantityInput.value) || 1;
        } else if (quantityDisplay) {
          currentQuantity = parseInt(quantityDisplay.textContent.trim()) || 1;
        }
        
        if (currentQuantity !== 1) {
          corrections.push({ lineKey, quantity: 1 });
        }
      }
    });
    
    // Apply corrections if needed
    if (corrections.length > 0) {
      for (const correction of corrections) {
        try {
          await fetch(`${window.Shopify?.routes?.root || ''}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: correction.lineKey,
              quantity: 1
            })
          });
        } catch (e) {
          console.warn('Failed to correct quantity for no-quantity product:', e);
        }
      }
      // Reload cart page if on cart page
      if (window.location.pathname === '/cart') {
        window.location.reload();
      }
    }
  }

  // Re-enforce after cart updates
  document.addEventListener('cart:change', function() {
    setTimeout(() => {
      enforceNoQuantityProducts();
      correctNoQuantityProductsInCart();
    }, 100);
  });

  // Also re-enforce after cart refresh (triggered by auto-discount)
  document.addEventListener('cart:refresh', function() {
    setTimeout(() => {
      enforceNoQuantityProducts();
      correctNoQuantityProductsInCart();
    }, 200);
  });

  // Testing/Debug Helper - Available in console as window.testNoQuantity()
  window.testNoQuantity = function() {
    console.log('🧪 Testing No-Quantity Implementation...\n');
    
    const results = {
      productsFound: 0,
      productsWithCorrectQuantity: 0,
      productsWithDisabledInputs: 0,
      productsWithDisabledButtons: 0,
      issues: []
    };

    // Find all no-quantity products
    const noQuantityProducts = document.querySelectorAll('[data-no-quantity="true"]');
    results.productsFound = noQuantityProducts.length;

    console.log(`📦 Found ${results.productsFound} product(s) with no-quantity tag\n`);

    if (noQuantityProducts.length === 0) {
      console.warn('⚠️  No products with no-quantity tag found in cart.');
      console.log('💡 To test: Add a product with the "no-quantity" tag to your cart.\n');
      return results;
    }

    noQuantityProducts.forEach((product, index) => {
      console.log(`\n🔍 Checking Product ${index + 1}:`);
      
      // Check quantity inputs
      const quantityInputs = product.querySelectorAll('input[type="number"][data-line-key]');
      quantityInputs.forEach(input => {
        const quantity = parseInt(input.value) || 0;
        const isDisabled = input.hasAttribute('disabled') || input.hasAttribute('readonly');
        const hasDataAttr = input.hasAttribute('data-no-quantity');
        
        console.log(`  📝 Quantity Input: ${quantity === 1 ? '✅' : '❌'} Quantity = ${quantity}`);
        console.log(`     ${isDisabled ? '✅' : '❌'} Input is ${isDisabled ? 'disabled/readonly' : 'enabled'}`);
        console.log(`     ${hasDataAttr ? '✅' : '❌'} Has data-no-quantity attribute`);
        
        if (quantity === 1) results.productsWithCorrectQuantity++;
        if (isDisabled) results.productsWithDisabledInputs++;
        
        if (quantity !== 1) {
          results.issues.push(`Product ${index + 1}: Quantity is ${quantity}, should be 1`);
        }
        if (!isDisabled) {
          results.issues.push(`Product ${index + 1}: Input is not disabled`);
        }
      });

      // Check quantity buttons
      const quantityButtons = product.querySelectorAll('.quantity-selector__button');
      let disabledButtons = 0;
      quantityButtons.forEach(button => {
        const isDisabled = button.disabled || button.style.pointerEvents === 'none';
        if (isDisabled) disabledButtons++;
      });
      
      console.log(`  🔘 Quantity Buttons: ${disabledButtons === quantityButtons.length ? '✅' : '❌'} ${disabledButtons}/${quantityButtons.length} disabled`);
      if (disabledButtons === quantityButtons.length) {
        results.productsWithDisabledButtons++;
      } else {
        results.issues.push(`Product ${index + 1}: Not all buttons are disabled`);
      }

      // Check display quantity (for cart page)
      const quantityDisplay = product.querySelector('td:nth-child(2) span');
      if (quantityDisplay) {
        const displayQuantity = parseInt(quantityDisplay.textContent.trim()) || 0;
        console.log(`  📊 Display Quantity: ${displayQuantity === 1 ? '✅' : '❌'} Shows ${displayQuantity}`);
        if (displayQuantity !== 1) {
          results.issues.push(`Product ${index + 1}: Display shows ${displayQuantity}, should show 1`);
        }
      }
    });

    // Summary
    console.log('\n' + '='.repeat(50));
    console.log('📊 TEST SUMMARY:');
    console.log('='.repeat(50));
    console.log(`✅ Products Found: ${results.productsFound}`);
    console.log(`${results.productsWithCorrectQuantity === results.productsFound ? '✅' : '❌'} Correct Quantity (1): ${results.productsWithCorrectQuantity}/${results.productsFound}`);
    console.log(`${results.productsWithDisabledInputs === results.productsFound ? '✅' : '❌'} Disabled Inputs: ${results.productsWithDisabledInputs}/${results.productsFound}`);
    console.log(`${results.productsWithDisabledButtons === results.productsFound ? '✅' : '❌'} Disabled Buttons: ${results.productsWithDisabledButtons}/${results.productsFound}`);
    
    if (results.issues.length > 0) {
      console.log('\n❌ ISSUES FOUND:');
      results.issues.forEach(issue => console.log(`   • ${issue}`));
    } else {
      console.log('\n✅ All tests passed! No-quantity functionality is working correctly.');
    }
    console.log('='.repeat(50) + '\n');

    return results;
  };

  // Auto-run test on cart page load (only in development)
  if (window.location.pathname === '/cart' && window.location.search.includes('test=no-quantity')) {
    setTimeout(() => {
      console.log('🧪 Auto-running no-quantity test...');
      window.testNoQuantity();
    }, 1000);
  }

  // Re-enforce after DOM mutations (for dynamic cart updates)
  const cartObserver = new MutationObserver(() => {
    enforceNoQuantityProducts();
  });
  
  // Observe cart-related elements
  const cartElements = document.querySelectorAll('.order-summary__body, .cart-drawer__items, cart-drawer');
  cartElements.forEach(element => {
    if (element) {
      cartObserver.observe(element, {
        childList: true,
        subtree: true
      });
    }
  });

  // Auto-apply discount code when cart opens
  (function initAutoApplyDiscount() {
    // Check both cart drawer and cart page for discount code
    const cartDrawer = document.getElementById('cart-drawer');
    const cartPage = document.querySelector('.section-spacing--tight[data-auto-discount-code]');
    
    let discountCode = cartDrawer?.getAttribute('data-auto-discount-code') || 
                       cartPage?.getAttribute('data-auto-discount-code');
    
    if (!discountCode || discountCode.trim() === '') {
      return; // No discount code configured
    }

    let hasAppliedDiscount = false;
    const STORAGE_KEY = 'auto_discount_applied_' + discountCode.trim().toUpperCase();

    /**
     * Check if discount is already applied to the cart
     * @returns {Promise<boolean>}
     */
    async function checkDiscountApplied() {
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
        if (!response.ok) return false;
        
        const cart = await response.json();
        return cart.discount_codes && cart.discount_codes.length > 0;
      } catch (error) {
        console.warn('Error checking cart discount:', error);
        return false;
      }
    }

    /**
     * Apply discount code to cart
     * @param {string} code - The discount code to apply
     * @returns {Promise<boolean>}
     */
    async function applyDiscountCode(code) {
      try {
        // Check if already applied
        const alreadyApplied = await checkDiscountApplied();
        if (alreadyApplied) {
          return true;
        }

        // Check localStorage to avoid multiple attempts
        if (sessionStorage.getItem(STORAGE_KEY) === 'true') {
          return true;
        }

        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            discount: code.trim()
          })
        });

        if (!response.ok) {
          const error = await response.json();
          console.warn('Failed to apply discount code:', error);
          return false;
        }

        const cart = await response.json();
        
        // Mark as applied in session storage
        sessionStorage.setItem(STORAGE_KEY, 'true');
        
        // Trigger cart refresh event
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        
        return true;
      } catch (error) {
        console.warn('Error applying discount code:', error);
        return false;
      }
    }

    /**
     * Handle cart drawer opening
     */
    function handleCartDrawerOpen() {
      if (hasAppliedDiscount) return;
      
      // Small delay to ensure cart is ready
      setTimeout(async () => {
        const applied = await applyDiscountCode(discountCode);
        if (applied) {
          hasAppliedDiscount = true;
        }
      }, 300);
    }

    /**
     * Handle cart page load
     */
    async function handleCartPageLoad() {
      if (window.location.pathname === '/cart') {
        // Check if discount already applied
        const alreadyApplied = await checkDiscountApplied();
        if (!alreadyApplied && sessionStorage.getItem(STORAGE_KEY) !== 'true') {
          await applyDiscountCode(discountCode);
        }
      }
    }

    /**
     * Apply discount on page load if cart has items
     */
    async function handlePageLoad() {
      try {
        // Check if cart has items
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
        if (!response.ok) return;
        
        const cart = await response.json();
        
        // Only apply if cart has items and discount not already applied
        if (cart.item_count > 0) {
          const alreadyApplied = await checkDiscountApplied();
          if (!alreadyApplied && sessionStorage.getItem(STORAGE_KEY) !== 'true') {
            await applyDiscountCode(discountCode);
          }
        }
      } catch (error) {
        // Silently fail - cart might not be accessible yet
        console.debug('Auto-discount: Could not check cart on page load', error);
      }
    }

    // Listen for cart drawer open events
    if (cartDrawer) {
      cartDrawer.addEventListener('dialog:after-show', handleCartDrawerOpen);
      cartDrawer.addEventListener('dialog:before-show', handleCartDrawerOpen);
    }

    // Handle cart page load
    if (window.location.pathname === '/cart') {
      handleCartPageLoad();
    }

    // Apply discount on any page load if cart has items
    // Small delay to ensure page is fully loaded
    setTimeout(() => {
      handlePageLoad();
    }, 500);

    // Also listen for cart changes to re-apply if needed
    document.addEventListener('cart:change', async (event) => {
      if (event.detail?.cart && !hasAppliedDiscount) {
        const alreadyApplied = await checkDiscountApplied();
        if (!alreadyApplied) {
          await applyDiscountCode(discountCode);
        }
      }
    });

    // Reset on page unload to allow re-application on next session
    window.addEventListener('beforeunload', () => {
      sessionStorage.removeItem(STORAGE_KEY);
    });
  })();
});